import React from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { Tabs } from 'antd'
import * as actions from './action'
import SummaryTab from './component/SummaryTab'
import DetailTab from './component/DetailTab'

const { TabPane } = Tabs

class TableUsageStatistics extends React.Component {
  render() {
    const { summaryList, detailList } = this.props
    return (
      <div className="page_container">
        <Tabs defaultActiveKey="summary">
          <TabPane tab="汇总" key="summary">
            <SummaryTab
              list={summaryList}
              onFetchSummary={this.props.fetchSummary}
              onExport={this.props.exportSummary}
            />
          </TabPane>
          <TabPane tab="明细" key="detail">
            <DetailTab
              list={detailList}
              onFetchDetail={this.props.fetchDetail}
              onExport={this.props.exportDetail}
            />
          </TabPane>
        </Tabs>
      </div>
    )
  }
}

const mapStateToProps = (state) => ({
  summaryList: state.getTableUsageStatistics.summaryList,
  detailList: state.getTableUsageStatistics.detailList,
})

export default withRouter(connect(mapStateToProps, actions)(TableUsageStatistics))



// WEBPACK FOOTER //
// ./src/containers/TableUsageStatistics/index.js